import Vue from "vue";

class OtpService {
    sessionTimeKey = "timeout_otp";
    sessionDataKey = "data_otp";

    setSessionTimeoutOtp(currentTime = 0) {
        sessionStorage.setItem(this.sessionTimeKey, currentTime);
    }

    getSessionTimeoutOtp() {
        const time = Number(sessionStorage.getItem(this.sessionTimeKey));
        return Number.isNaN(time) ? 0 : time;
    }

    clearSessionTimeoutOtp() {
        sessionStorage.removeItem(this.sessionTimeKey);
    }

    isHaveSessionTimeoutOtp() {
        const time = sessionStorage.getItem(this.sessionTimeKey);
        return time ? true : false;
    }

    setSessionData(data = {}) {
        sessionStorage.setItem(this.sessionDataKey, JSON.stringify({...data}));
    }

    getSessionData() {
        return sessionStorage.getItem(this.sessionDataKey) ? JSON.parse(sessionStorage.getItem(this.sessionDataKey)) : {};
    }

    clearSessionData() {
        sessionStorage.removeItem(this.sessionDataKey);
    }

    // API SERVICE BELOW
    
    /**
     * @description To invoke the api get new otp for user
     * @param {{ token }} data 
     * @returns 
     */
    async allocationOtp(data = {}) {
        try {
            return await Vue.axios.post("/otp/allocation-otp", data)  
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description To check the token otp has expired.
     * Promise.resolve() : If it have expiry date to use.
     * Promise.reject() : It has expired time.
     * 
     * @param {{token}} data 
     * @returns 
     */
    async otpLinkHasExpired(data = {}) {
        try {
            return await Vue.axios.post("/otp/has-expired-otp", data);
        } catch(e) {
            return Promise.reject(e);
        }
    }
}

const otpService = new OtpService();

export default otpService;


// WEBPACK FOOTER //
// ./src/core/services/otpService.js